import {Component, computed, inject, signal} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {MatFormField} from '@angular/material/input';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatOption, MatSelect} from '@angular/material/select';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {Subscription} from 'rxjs';
import {take} from 'rxjs/operators';
import {IackathonProgressViewerComponent} from '../../components/iackathon-progress-viewer/iackathon-progress-viewer.component';
import {IackathonStepDetailsComponent} from '../../components/iackathon-step-details/iackathon-step-details.component';
import {IACKATHON_STEP} from '../../models/iackathon_steps';
import {IackathonSavesService} from '../../services/iackathon-saves.service';

@Component({
  selector: 'app-iackathon-group-details-page',
    imports: [
        RouterLink,
        MatFormField,
        MatSelect,
        MatOption,
        IackathonProgressViewerComponent,
        MatProgressSpinner,
        IackathonStepDetailsComponent
    ],
  templateUrl: './iackathon-group-details-page.component.html',
  styleUrl: './iackathon-group-details-page.component.scss',
})
export class IackathonGroupDetailsPageComponent {
    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);
    private iackathonSavesService = inject(IackathonSavesService);

    protected readonly isLoading = signal(false)
    private readonly urlParams = toSignal(this.activatedRoute.paramMap)
    protected readonly groupSaveId = computed(() => this.urlParams().get('id') ?? '')
    protected readonly groupSaves = this.iackathonSavesService.cachedSaves;
    protected readonly selectedSave= computed(() => this.groupSaves().find(save => save.id === this.groupSaveId()) ?? null)
    protected readonly activeStep = signal<IACKATHON_STEP>("keyNumber")

    constructor() {
        if (this.iackathonSavesService.cachedSaves().length === 0) {
            this.isLoading.set(true);
            this.iackathonSavesService.fetchSaves().pipe(
                take(1)
            ).subscribe(() => this.isLoading.set(false));
        }
    }

    protected onSelectSaveChange(selectedSaveId: string): void {
        this.router.navigate(['/iackathon-groups', selectedSaveId]);
    }
}
